// <div data-controller="admin--leads">
//
// </div>
import { Controller } from "stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "rewardCheckBox" ];
  static classes = [ "" ]
  static values = {};

  initialize() {

  }

  bulkReward(e) {
    let formData = new FormData();
    let campaignLeadIds = [];
    this.rewardCheckBoxTargets.forEach((target) => {
      if (target.checked) {
        campaignLeadIds.push(target.dataset.campaignLeadId);
        formData.append("campaign_lead_ids[]", target.dataset.campaignLeadId);
      }
    })

    if (campaignLeadIds.length === 0) {
      alert("please select at least one lead.")
      return;
    }
    e.target.disabled = true;
    if (confirm(`Are you sure to REWARD ${campaignLeadIds.length} leads? (ID :${campaignLeadIds})`)) {
      e.target.innerText = "requesting..."
      e.target.classList.add("cursor-progress")
      api.post("/admin/campaign_leads/bulk_reward", formData).then((response) => {
        location.reload()
      })
    } else {
      e.target.disabled = false;
    }
  }

  bulkReject(e) {
    let leadIds = []
    this.rewardCheckBoxTargets.forEach((target) => {
      if (target.checked) {
        leadIds.push(target.dataset.campaignLeadId);
      }
    })
    this.rejectLeads(e.target, leadIds);
  }

  singleReject(e) {
    const { leadId } = e.target.dataset;
    this.rejectLeads(e.target, [leadId]);
  }

  rejectLeads(target, leadIds) {
    if (leadIds.length === 0) {
      alert("please select at least one lead.")
      return;
    }

    target.disabled = true;
    const sophie_message_content = prompt(`Are you sure to REJECT ${leadIds.length} leads? (ID :${leadIds})\n\nEnter rejection sophie message content if you want to start sophie chat with each users. Leave it blank and submit to skip sophie.`);

    if (sophie_message_content === null) {
      target.disabled = false;
      return;
    }

    target.innerText = "requesting..."
    target.classList.add("cursor-progress")

    let formData = new FormData();

    formData.append("sophie_message_content", sophie_message_content)
    leadIds.forEach((leadId) => {
      formData.append("campaign_lead_ids[]", leadId);
    })

    api.post("/admin/campaign_leads/bulk_reject", formData).then((response) => {
      location.reload()
    })
  }

  connect() {

  }

  disconnect() {

  }
}